import { createElement } from "react";

import { FileOutlined } from "@ant-design/icons";

import {
	type SubRouteConfig,
	type TableAction,
	type TableActionContext,
} from "@neu/libui";
import { buildApiUrl, fetchApi } from "@neu/libui";

import { renderCallNotes } from "./CallNotesCell";
import { PatientCaseList } from "./PatientCaseList";
import { PatientCommunication } from "./PatientCommunication";
import { PatientSnapshot } from "./PatientSnapshot";

type PatientSubNavItem = SubRouteConfig & {
	label: string;
};

export const patientSubNavItems: PatientSubNavItem[] = [
	{
		path: "snapshot",
		label: "Snapshot",
		entity: "",
		listComponent: PatientSnapshot,
	},
	{
		path: "communication",
		label: "Communication",
		entity: "",
		listComponent: PatientCommunication,
	},
	{
		path: "call",
		label: "Call Note Log",
		entity: "patient_call",
		componentProps: {
			entityColOverride: {
				internal_note: {
					wrap: true,
					render: renderCallNotes,
				},
			},
		},
	},
	{
		path: "welcome-call",
		label: "Welcome Call",
		entity: "patient_welcome_call",
		componentProps: {
			showAddButton: false,
		},
	},
	{ path: "coverage", label: "Coverage", entity: "patient_insurance" },
	{
		path: "case",
		label: "Case",
		entity: "patient_case",
		listComponent: PatientCaseList,
	},
	{
		path: "dispense",
		label: "Dispense Log",
		entity: "patient_order_dispense",
	},
	{
		path: "claim-lines",
		label: "Claim Lines",
		entity: "plan_claim_dispense",
		componentProps: {
			showAddButton: false,
			showEditButton: false,
		},
	},
	{ path: "pap", label: "PAP", entity: "patient_pap" },
	{ path: "copay-program", label: "Copay", entity: "patient_copay_program" },
	{
		path: "discount-drug-program",
		label: "Discount Drug Program 340B",
		entity: "discount_drug_program",
	},
	{
		path: "attachment",
		label: "File Attachment",
		entity: "patient_attachment",
		componentProps: {
			rowSelectionMode: "multi",
			tableActions: [
				{
					key: "download",
					label: "Download",
					icon: createElement(FileOutlined),
					isEnabled: () => true,
					onClick: (data: TableActionContext) => {
						void (async () => {
							const result = await fetchApi(
								buildApiUrl(
									`/pdf/print/patient-attachment?patient_id=${data.filters.patient_id}&ids=${data.selectedRows.map((row) => row.id).join(",")}`
								),
								{ parseAs: "blob" }
							);
							const { blob } = result;

							const url = URL.createObjectURL(blob);
							window.open(url, "_blank");
						})();
					},
				},
			] satisfies TableAction[],
		},
	},
	{ path: "schedule", label: "Schedule Event", entity: "patient_schedule" },
	{ path: "faxes", label: "Faxes", entity: "faxes" },
];

export const pbmPortalPatientSubNavItems = patientSubNavItems.filter(
	(item) => item.path !== "communication"
);
